<template>
  <div class="screen screen-rotation" :class="{'has-padding':currentSession && !allOver}">
    <header class="screen-header p-d-flex p-ai-center p-jc-between p-mb-1">
      <main-menu>
        <img src="/static/img/neu-logo.png" width="100" />
      </main-menu>
      <div class="p-align-center">
        <span>{{currentDateStr}}</span>
        <br/>
        <digital-clock blink="true"/>
      </div>
      <!--
      <span v-if="inSession">In session</span>
      <span v-else>Not in session</span>
      -->
    </header>

    <session-view
      v-if="loaded && currentSession"
      :session="currentSession"
      :key="`session-view-${currentSession.id}`"
    />
    <div class="loading-container" v-if="!loaded">
      <loading-indicator/>
    </div>
    <div class="all-over" v-if="allOver">

    </div>

    <!--
    <div v-resize-text>This is the screen for the foyers</div>
    <div v-if="motions">
      <ul>
        <li v-for="motion in motions" :key="motion.id">
          {{motion.name}}
        </li>
      </ul>
    </div>
    <div class="p-grid">
      <div class="p-col">1</div>
      <div class="p-col">2</div>
      <div class="p-col">3</div>
    </div>
    -->
  </div>

</template>

<script>

import cron from '../../mixins/cron'
import DigitalClock from 'vue-digital-clock'
import Motion from '../../models/motion'
import currentMotionData from '../../temp/current-motion.json'
import SessionView from '../sessions/SessionView.vue'
import LoadingIndicator from '../loaders/LoadingIndicator.vue'
import MainMenu from '../nav/MainMenu.vue'

export default {
  name: 'RotationScreen',
  mixins: [
    cron
  ],
  components: {
    DigitalClock,
    'session-view': SessionView,
    LoadingIndicator,
    MainMenu
  },
  data: function () {
    return {
      loading: false,
      loaded: false,
      motions: null
    }
  },
  computed: {
    currentDateStr () {
      return new Date().toLocaleDateString('en-gb',
        {weekday: 'long', month: 'long', day: 'numeric'})
    },
    currentSession () {
      // return false
      return this.$store.getters['sessions/currentOrNext']
    },
    inSession () {
      return this.$store.getters['sessions/current'] !== null &&
        this.$store.getters['sessions/current'] !== undefined
    },
    allOver () {
      return this.$store.getters['sessions/allOver']
    }
  },
  async created () {
    /**
    const response = await this.$http.get(
      config.uri,
      {
        params: {
          r: 'event-session-api/index',
          token: config.authToken,
          _username: config.username
        },
        headers: {
          'Origin': config.origin
        }
      }
    )
      **/

    console.log(this)

    await this.$store.dispatch('motions/load', {screen: 'rotation'})
    // await this.$store.dispatch('motions/loadOne', 3)
    // if (this.$store.getters['sessions/empty']) {
    /**
    let sessions = await this.$store.$api.getSessions()
    console.log(sessions)
    this.$store.commit('sessions/SET_ALL', sessions)
    **/
    await this.$store.dispatch('sessions/load')
    // }

    const currentMotion = Motion.fromCurrentJson(currentMotionData)
    console.log(currentMotion)

    this.loaded = true

    // const response3 = await this.$store.$api.getSpeakers(response2[0])
    // console.log(response3)

    /**
    const response2 = await this.$store.$api.getMotions()
    console.log(response2)

    const response3 = await this.$store.$api.getCurrentMotion()
    console.log(response3)
    **/
    // this.motions = tempData.models.map((d) => Motion.fromJson(d))
    // console.log(this.motions)
    // this.$store.commit('motions/SET_ALL', this.motions)

    /**
    let motion = this.$store.getters['motions/getById'](2)
    console.log(motion.name)
    motion.name = 'foo'
    this.$store.commit('motions/UPDATE', motion)
**/

    // const response = await this.$http.get('https://github.com/pagekit/vue-resource/blob/develop/docs/recipes.md', {})
  }
  /**
  cron: [
    {
      time: 10000,
      method: 'runScheduler'
    }
  ]
    **/
}
</script>

<style scoped>
.screen {
  font-size: 0.9rem;
}
time.clock {
  font-family: technologybold, monospace;
  letter-spacing: 0.2rem;
  font-size: 3rem;
  font-weight: bold;
}
.background {
  width: 100vw;
  height: 100vh;
  background: url('/static/img/2024/bg-narrow.png');
}
.all-over {
  width: 100vw;
  height: 100vh;
  background: url('/static/img/2026/2026-graphic.png');
  background-size: cover;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/rotation/RotationScreen.vue